'use strict';

export { default } from './report.container';